import { render } from "./CustomDivider.vue?vue&type=template&id=cf26ec80"
const script = {}

import exportComponent from "C:\\Users\\Admin\\Documents\\LoesusPedagogia\\LoesusOFSite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__